import Alpine from 'alpinejs'
import 'jquery';
import modules from './modules/modules.js';
import './paginator/infinite'
import Headroom from 'headroom.js'
import scrollLock from 'scroll-lock'


window.Alpine = Alpine

document.addEventListener('alpine:init', () => {
  Alpine.store('menu', {
    open: false,
    toggle() {
      this.open = !this.open
      if (this.open) {
        scrollLock.disablePageScroll()
      } else {
        scrollLock.enablePageScroll()
      }
    }
  })
})

Alpine.start()

var headroom = new Headroom(document.querySelector('.header'), {offset: 50})
headroom.init()

$(document).ready(() => {
  modules();
});
